import { defaultTo } from 'lodash';

import { IAuction } from '../../../../../redux/reducers';
import { IAuctionSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { mapAuctionStrategy } from './mapAuctionStrategy';
import { mapPeriod } from '../mapPeriod';
import { mapAuctionConfigurations } from './mapAuctionConfigurations';
import { mapAuctionServiceCosts } from './mapAuctionServiceCosts';

export function mapAuction(auctionTerm?: IAuctionSchema | null): IAuction {
  const { auctionInfo, strategyInfo: rawStrategy, incompatibleServices, isAvailable } = auctionTerm || {};

  const {
    defaultBet,
    currentBet,
    maximalBet,
    minimalBet,
    configurations: rawConfigurations,
    serviceCosts: rawServiceCosts,
    nextBets,
    previousBets,
  } = auctionInfo || {};

  const configurations = mapAuctionConfigurations(rawConfigurations);
  const serviceCosts = mapAuctionServiceCosts(rawServiceCosts);
  const strategy = mapAuctionStrategy(rawStrategy);

  const rawPeriod = auctionTerm?.period;
  const period = rawPeriod ? mapPeriod(rawPeriod) : null;

  // На бэке сейчас в currentBet кладется стоимость выбранной услуги, а нет ставка
  // поэтому вычисляем максимальное значения, чтобы выбрать цену топ или топ+ставка
  const maxBetValue = Math.max(defaultTo(currentBet, 0), defaultTo(defaultBet, 0));

  return {
    isEnabled: !!auctionTerm && !!isAvailable,
    currentBet: maxBetValue,
    minimalBet: minimalBet || 1,
    maximalBet: maximalBet || 99,
    incompatibleServices: incompatibleServices || [],
    configurations,
    serviceCosts,
    period,
    strategy,
    nextBets: nextBets || [],
    previousBets: previousBets || [],
  };
}
